import { useState } from 'react';

import { Modal } from '@iwoca/orion';

import { usePayLinkFeeContext } from '../../hooks/usePayLinkFeeContext.hook';
import { INDEFINITE_END_DATE } from '../../utils/constants';
import { ModalTable } from '../components/ModalTable';
import { formatDate } from '../RateContextHeader/RateContextHeader';

export const PromotionalRatesModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <PromotionalRates />
      </Modal>
      <button
        onClick={() => setIsOpen(true)}
        className="cursor-pointer bg-transparent p-0 text-s font-med text-primary-40 underline"
      >
        See promo history
      </button>
    </>
  );
};

export const PromotionalRates = () => {
  const { data: feeContext, isLoading } = usePayLinkFeeContext();

  const hasNoPromotionsHistory = feeContext?.data.promotional.all.length === 0;
  const loading = isLoading;

  return (
    <div>
      <h2 className="mb-s">Your promotional rates</h2>
      <div className="mb-l text-m font-reg">
        This is a historical list of all of your promotional rates for iwocaPay
        Pay Later transaction fees.
      </div>

      <ModalTable
        isLoading={loading}
        isEmpty={hasNoPromotionsHistory}
        tableHeaderRow={
          <tr>
            <th>Promo period</th>
            <th>Product</th>
            <th>Promo rate</th>
            <th>Status</th>
          </tr>
        }
      >
        <>
          {feeContext?.data.promotional.all!.map(
            ({ id, start, end, product, fee_percentage }) => {
              const isIndefinite = end === INDEFINITE_END_DATE;
              const dateRange = isIndefinite
                ? `${formatDate(start)} – ongoing`
                : `${formatDate(start)} – ${formatDate(end)}`;

              return (
                <tr key={id}>
                  <td>{dateRange}</td>
                  <td>
                    <div>{product === 'THREE_MONTHS' ? '3' : '12'} months</div>
                  </td>
                  <td>{fee_percentage}%</td>
                  <td>
                    {feeContext?.data.promotional.active.find(
                      (rate) => rate.id === id,
                    )
                      ? 'Active'
                      : 'Inactive'}
                  </td>
                </tr>
              );
            },
          )}
        </>
      </ModalTable>
    </div>
  );
};
